// @flow
import React from 'react';
import type {
  Issue,
} from 'chronos-types';
import * as R from 'ramda';
import {
  Status,
} from '@atlaskit/status/element';

import {
  SidebarItemContainer,
  SidebarItemHeader,
  SidebarItemTitle,
  SidebarItemImage,
  SidebarItemSubtitle,
} from './styled';

type Props = {
  /**
   * Issue which was logged
   * */
  issue: Issue,
  /**
   * Sets whether the issue selected.
   * */
  selected?: boolean,
  /**
   * Function that is called after issue selected.
   * */
  onSelect: () => {},
  /**
   * Function that is called when the issue clicked.
   * */
  onClick?: { (id: string): void },
};
/**
 * SidebarIssueItem component responsible for rendering issues in Sidebar issues list
 * @version 1.0.0
 */
const SidebarIssueItem = ({
  selected,
  onSelect,
  onClick,
  issue,
}: Props) => (
  <SidebarItemContainer
    selected={selected}
    onSelect={onSelect}
    onClick={() => onClick(R.path(['id'], issue))}
  >
    <SidebarItemHeader>
      <SidebarItemTitle>
        {R.path(['key'], issue)}
      </SidebarItemTitle>
      <div style={{
        marginTop: '2px',
        marginLeft: '2px',
      }}
      >
        <Status
          text={issue.fields.status?.name}
          color={issue.fields.status?.statusCategory.colorName}
        />
      </div>
    </SidebarItemHeader>
    <SidebarItemSubtitle>
      <SidebarItemImage
        src={R.path(['fields', 'priority', 'iconUrl'], issue)}
        alt="priorityImg"
      />
      <SidebarItemImage
        src={R.path(['fields', 'issuetype', 'iconUrl'], issue)}
        alt="issueType"
      />
      {R.path(['fields', 'summary'], issue)}
    </SidebarItemSubtitle>
  </SidebarItemContainer>
);

SidebarIssueItem.defaultProps = {
  selected: false,
  onClick: () => {},
};

export default SidebarIssueItem;
